import React from "react";
import Image from "components/image";
import { Swiper, SwiperSlide } from "components/swiper";
import { Mousewheel, Pagination } from "swiper";
import "swiper/css/pagination";

const settings = {
	modules: [Mousewheel, Pagination],
	slidesPerView: 1.6,
	preventClicks: true,
	pagination: {
		clickable: true,
		el: ".swiper-pagination",
		type: "bullets",
	},
	slidesOffsetBefore: 16,
	slidesOffsetAfter: 10,
	preventClicksPropagation: false,
	spaceBetween: 10,
	mousewheel: {
		enabled: true,
		forceToAxis: true,
	},
	slidesPerGroup: 1,
	breakpoints: {
		768: {
			slidesOffsetBefore: 50,
		},
	},
};

const ProductGallery = ({ images }) => (
	!images?.length ? null : (
		<div>
			<div className="flex relative justify-between">
				<Swiper {...settings}>
					{images.map((image) => (
						<SwiperSlide key={image._key}>
							<Image image={image} alt={image?.alt} />
						</SwiperSlide>
					))}
				</Swiper>
			</div>
			<div className="swiper-pagination"></div>
		</div>
	)
);

export default ProductGallery;